import wrapPageElement from './wrapPageElement';
import wrapRootElement from './wrapRootElement';

const onClientEntry = () => {
  // polyfill for intersection observer
  require('intersection-observer');
};

export { wrapPageElement, wrapRootElement, onClientEntry };
